module.exports = __webpack_public_path__ + "media/country_flags/na-f14a945c.png";